<template>
  <div class="scroll-list" v-if="scrollList.length > 0">
    <ul>
      <li v-for="(item, index) in scrollList">
        <p v-if="item.type == 'H4'" class="main-link" :id="item.title" @click="scrollTo(item,$event)">{{ item.title}}</p>
        <p v-if="item.type == 'H5'" class="sub-link" :id="item.title" @click="scrollTo(item,$event)">{{ item.title}}</p>
      </li>
    </ul>
  </div>
</template>

<script>
  /* eslint-disable */
  export default {
    name: 'ScrollNav',
    props: ['scrollList'],
    data() {
      return {
        lan: this.$route.params.language
      }
    },
    mounted() {
      window.addEventListener('scroll', this.onScrollPage)
    },
    methods:{
      scrollTo(item,e){
        $('.scroll-list').find('p').removeClass('active');
        $(e.target).addClass('active');
        $('html, body').animate({  
            scrollTop: $(item.ele).offset().top  
        }, 200);  
      },
      onScrollPage(e) {
        for(let i =0 ;i<this.scrollList.length; i++){
          const item = this.scrollList[i];
          if(item.offsetTop >= window.scrollY){
            $('.scroll-list').find('p').removeClass('active')
            $('[id="'+$(item.ele).text()+'"]').addClass('active');
            break;
          }
        }
      },
    }
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .scroll-list{
    position: fixed;
    top: 200px;
    right: 30px;
    width: 200px;
    color: #000000;
    background: #fff;
    border:1px solid #eee;
    ul{
      padding-left: 0 15px;
      li{
        list-style: none;
      }
      p{
        font-size: 14px;
        cursor: pointer;
        &:hover{
          color:#00a6ff;
        }
        &.active{
          color: #00a6ff;
        }
      }
    }
    .sub-link{
      padding-left: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// ScrollNav.vue?1038a47e